// import Swiper JS
import Swiper, {
    Autoplay,
    Navigation
} from 'swiper';
// import Swiper styles
import 'swiper/css';

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation]);

export function initMultiTabbedContent() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=multi-tabbed-content',
            multiTabbedContent
        );
    }
}

export function multiTabbedContent() {

    if (!document.querySelectorAll('.multi-tabbed-content-carousel'))
        return;

    const carousels = document.querySelectorAll('.multi-tabbed-content-carousel');
    carousels.forEach((carousel) => {
        let carouselid = carousel.id;

        let next = document.querySelector('.multi-tabbed-content-carousel-prev');
        let prev = document.querySelector('.multi-tabbed-content-carousel-next');
        let tabs = document.querySelectorAll('.multi-tab-tab[swiper-id="' + carouselid + '"]');

        let swiperinstance = new Swiper(carousel, {
            // Optional parameters
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            on: {
                init: (swiper) => {
                    updateTabs(swiper, tabs);
                },
                slideChangeTransitionEnd: (swiper) => {
                    updateTabs(swiper, tabs);
                }
            }
        });


        tabs.forEach((tab) => {
            let index = tab.dataset.multiTabIndex;
            tab.addEventListener('click', (e) => {
                swiperinstance.slideToLoop(index);
            });
        });
    });
}
function updateTabs(swiper, tabs) {
    tabs.forEach((tab) => {
        const index = tab.dataset.multiTabIndex;

        if (index == swiper.realIndex) {
            tab.classList.add('!text-mc-pink');
            tab.classList.add('!border-mc-pink');
            tab.classList.remove('text-mc-grey-extra-dark');
        } else {
            tab.classList.remove('!text-mc-pink');
            tab.classList.remove('!border-mc-pink');
            tab.classList.add('text-mc-grey-extra-dark');
        }
    });
}
